import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import { AuthProvider } from "@/context/AuthContext";
import AnnouncementBar from "@/components/AnnouncementBar";
import Header from "@/components/Header";
import CartDrawer from "@/components/CartDrawer";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import CategoriesPage from "@/pages/CategoriesPage";
import BestSellersPage from "@/pages/BestSellersPage";
import ProductPage from "@/pages/ProductPage";
import About from "@/pages/About";
import OurStory from "@/pages/OurStory";
import ContactPage from "@/pages/ContactPage";
import AccountPage from "@/pages/AccountPage";
import OrderDetailPage from "@/pages/OrderDetailPage";
import AuthCallback from "@/pages/AuthCallback";
import Checkout from "@/pages/Checkout";
import PolicyPage from "@/pages/PolicyPage";

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      setTimeout(() => document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" }), 150);
    } else {
      window.__lenis?.scrollTo(0, { immediate: true });
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App">
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <ScrollManager />
            <AnnouncementBar />
            <Header />
            <CartDrawer />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/categories" element={<CategoriesPage />} />
              <Route path="/best-sellers" element={<BestSellersPage />} />
              <Route path="/product/:slug" element={<ProductPage />} />
              <Route path="/about" element={<About />} />
              <Route path="/our-story" element={<OurStory />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/account" element={<AccountPage />} />
              <Route path="/account/orders/:id" element={<OrderDetailPage />} />
              <Route path="/auth/callback" element={<AuthCallback />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/policies/:slug" element={<PolicyPage />} />
              <Route path="*" element={<Home />} />
            </Routes>
            <Footer />
            <Toaster
              position="bottom-right"
              toastOptions={{
                style: { background: "#121212", color: "#FAF9F6", border: "none", borderRadius: "12px" },
              }}
            />
          </BrowserRouter>
        </CartProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
